/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpHead_viewer = {|
  +isPdpUrlTranslationEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpHead_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isPdpUrlTranslationEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "translatedPdpUrls",
          "type": "String!"
        }
      ],
      "name": "isEnabled",
      "storageKey": "isEnabled{\"key\":\"translatedPdpUrls\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
